import { isServerResponseError, hasError } from "../common";
import { pathOr } from "ramda";
import getSharedCustomerQuarterlyUsage from "../../services/apis/get-shared-customer-quarterly-usage";

const getSharedConsumptionQuarterlyData = async (id, shareToken, from, to) => {
  const result = await getSharedCustomerQuarterlyUsage(id, {
    shareToken,
    from,
    to,
  });
  
  if (isServerResponseError(result) || hasError(result)) {
    return { data: [], costMonthRequest: [] };
  }
  
  // API returns result.data containing {data: [...], costMonthRequest: [...]}
  const responseData = pathOr({}, ["data"], result);
  const data = pathOr([], ["data"], responseData);
  const costMonthRequest = pathOr([], ["costMonthRequest"], responseData);
  
  // Return in the same format as customer detail page
  return {
    data: Array.isArray(data) ? data : [],
    costMonthRequest: Array.isArray(costMonthRequest) ? costMonthRequest : []
  };
};

export default getSharedConsumptionQuarterlyData;